<script>
  export let placeholder = ''
  export let className = 'w-full'
  export let name = ''
  export let val = ''
  export let focus = () => {}
  export let instanceForm = null
</script>

<div class="input pb-1 {className}">
  <input 
    class="box-border w-full p-4 text-sm text-gray-800 placeholder-gray-400 border-orange border rounded-3xl appearance-none h-10"
    type="text"
    {placeholder}
    {name}
    on:focus={focus}
    bind:value={val}
  >
  <div class="py-1">
    {#if $instanceForm.fields[name].errors.includes('required')}
      <span class="block w-full px-4 text-xs text-red-600 error">Campo requerido</span>
    {:else if $instanceForm.fields[name].errors.includes('email')}
      <span class="block w-full px-4 text-xs text-red-600 error">Email incorrecto</span>
    {:else if $instanceForm.fields[name].errors.includes('invalidPhone')}
      <span class="block w-full px-4 text-xs text-red-600 error">Teléfono incorrecto</span>
    {/if}
  </div>
</div>

<style lang="scss">

</style>